// prettier-ignore
export const validate = ({ titulo, date}: any) => {
    let aux = "";
    if (!titulo) aux = "Por favor rellene el título .";
    if (!date) aux = 'Por favor rellene la fecha.';


    return aux;
  };

